import { render, staticRenderFns } from "./ourApp.vue?vue&type=template&id=17066bc9&scoped=true&"
import script from "./ourApp.vue?vue&type=script&lang=js&"
export * from "./ourApp.vue?vue&type=script&lang=js&"
import style0 from "./ourApp.vue?vue&type=style&index=0&id=17066bc9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17066bc9",
  null
  
)

export default component.exports